export default __webpack_public_path__ + "static/media/img9.f831b704.png";